module.exports = "<section>\r\n    <label>{{categoryName}}</label>\r\n</section>\r\n"